module.exports = __webpack_public_path__ + "static/media/david2.66a9d9f2.jpg";